module.exports = __webpack_public_path__ + "img/05_off.686a8a30.png";